import axios from "axios";
import { ILoginTotem, ILoginTotemResponse } from "../models/totem-devices";

const TOTEM_DEVICE_ROUTE_HOMOLOG =
  "https://app.hml.4uhub.com.br/api/v1/TotemDevices/Login";
const TOTEM_DEVICE_ROUTE_DEV =
  "https://api.dev.4uhub.com.br/app/api/v1/TotemDevices/Login";
const TOTEM_DEVICE_ROUTE_PROD =
  "https://app.4uhub.com.br/api/v1/TotemDevices/Login";

export const loginTotem = (item: ILoginTotem) => {
  var route =
    item.connection === "1"
      ? TOTEM_DEVICE_ROUTE_PROD
      : item.connection === "2"
      ? TOTEM_DEVICE_ROUTE_HOMOLOG
      : TOTEM_DEVICE_ROUTE_DEV;

  return axios.post<ILoginTotemResponse>(route, item);
};
